// extracted by mini-css-extract-plugin
module.exports = {"subject":"Subject_subject__2Ep2q","subjectText":"Subject_subjectText__hu3bD"};